const sequences = {};

const sequenceGenerator = {
  max: (identifier: string) => {
    if (!(identifier in sequences)) {
      return -1;
    }
    return sequences[identifier];
  },
  next: (identifier: string) => {
    if (!(identifier in sequences)) {
      sequences[identifier] = 0;
    } else {
      sequences[identifier]++;
    }
    return sequences[identifier];
  }
};

export { sequenceGenerator };
